var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotespad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3135_8271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8334 4.66666L9.33335 2.16666L2.66669 8.83332V11.3333H5.16669L11.8334 4.66666ZM13.8067 2.69332C14.0667 2.43332 14.0667 2.01332 13.8067 1.75332L12.2467 0.193322C11.9867 -0.0666785 11.5667 -0.0666785 11.3067 0.193322L10 1.49999L12.5 3.99999L13.8067 2.69332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3333H16V16H0V13.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3135_8271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotespad);
export default __webpack_public_path__ + "static/media/Notespad.4b4445952f78aba2d6bdcf0ce4bd6142.svg";
export { ForwardRef as ReactComponent };